<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="6">
        <v-card>
          <v-card-text>
            <img :src="avatarImage" width="128" class="avatar-image" alt="Diogo">
            <h1 class="h1">Seja bem-vindo ao Sistema Cidade Empreendedora!</h1>
            <br>
            <p>Meu nome é Diogo, consultor de Políticas Públicas e Relações Governamentais do Sebrae-SP.</p>
            <p>Você concluiu a primeira fase do processo de cadastro do sistema. Para que possa visualizar o conteúdo de acordo com seu perfil, necessitamos parametrizar as permissões de usuário. Envie um whatsapp para <a href="https://wa.me/5511976338333">(11) 97633-8333</a> com seu nome e CPF para requisitar as permissões.</p>
            <p>Estou à disposição para quaisquer dúvidas sobre o sistema.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import avatarImage from './images/diogo.jpeg';
  import { isSPNewUser } from "@/helpers/utils";

  export default {
    mounted() {
      if (!isSPNewUser()) {
        this.$router.push("/cidade");
      }
    },
    data() {
      return {
        avatarImage
      }
    }
  }
</script>

<style scoped>
  .avatar-image {
    border-radius: 50%;
    overflow: hidden;
    float: left;
    margin-right: 16px;
    margin-bottom: 16px;
  }

  .h1 {
    line-height: 1.2;
  }
</style>
